import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, from, switchMap, throwError } from 'rxjs';
//import { FileDownload } from '../models/file/file-download';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  baseUrl = '';
  options: any = {
    withCredentials: true,
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }),
    responseType: 'json'
  };

  optionsFile: any = {
    withCredentials: true,
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    }),
    responseType: 'blob'
  };

  constructor(private http: HttpClient) { }

  setBaseUrl(url: any) {
    this.baseUrl = `${url}`;
  }

  get(model: any, method?: string) {
    const query = this.buildQueryString(model);
    let url = this.baseUrl;
    if (!!method) {
      url = `${this.baseUrl}${method}`;
    }

    return this.http.get(`${url}?${query}`, this.options);
  }

  getModel<T>(model: any, method?: string) {
    const query = this.buildQueryString(model);
    let url = this.baseUrl;
    if (!!method) {
      url = `${this.baseUrl}${method}`;
    }

    return this.http.get<T>(`${url}?${query}`, <Object>this.options);
  }

  getById(id: any) {
    return this.http.get(`${this.baseUrl}${id}`, this.options);
  }

  post(model: any, method?: string) {
    let url = this.baseUrl;
    if (!!method) {
      url = `${this.baseUrl}${method}`;
    }

    return this.http.post(`${url}`, model, this.options);
  }

  postFiles(model: any, method: string = "", ) {
    let url = this.baseUrl;
    if (!!method) {
      url = `${this.baseUrl}/${method}`;
    }
    return this.http.post(`${url}`, model, this.optionsFile);
  }

  postWithModel<T>(model: any, method?: string) {
    let url = this.baseUrl;
    if (!!method) {
      url = `${this.baseUrl}${method}`;
    }

    return this.http.post<T>(`${url}`, model, this.options);
  }

  postUrlEncodded(model: any, method?: string, extraheaders?: any) {
    let url = this.baseUrl;
    if (!!method) {
      url = `${this.baseUrl}${method}`;
    }

    const body = new URLSearchParams();
    for (const key in model) {
      body.set(key, model[key]);
    }

    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    for (const key in extraheaders) {
      headers = headers.append(key, extraheaders[key]);
    }

    return this.http.post(url, body.toString(), { headers: headers });
  }

  delete(id: any, method?: string) {
    let url = this.baseUrl;
    if (!!method) {
      url = `${this.baseUrl}${method}`;
    }

    return this.http.delete(`${url}/${id}`, this.options);
  }

  buildQueryString(model: any) {
    const queryString = Object.keys(model).map((key) => key + '=' + model[key]).join('&');
    return queryString;
  }

  // protected downloadBase64WithPost(model: any, method: string, callback?: () => void, error?: () => void) {
  //   let url = this.baseUrl;
  //   if (!!method) {
  //     url = `${this.baseUrl}${method}`;
  //   }

  //   this.http.post(url, model, { responseType: 'blob', observe: 'response' })
  //     .subscribe(async (response: any) => {
  //       const blobText = await response.body.text();

  //       const model: FileDownload = JSON.parse(blobText);
  //       if (!!callback) {
  //         callback();
  //       }

  //       return this.convertBase64ToPDF(model);
  //     }, (err: any) => {
  //       if (!!error) {
  //         error();
  //       }
  //     });
  // }


 openBase64WithPost(model: any, method: string, callback?: () => void, error?: () => void) {
  let url = this.baseUrl;
  if (!!method) {
    url = `${this.baseUrl}${method}`;
  }

  return this.http.post(url, model, { responseType: 'blob', observe: 'response' })
    .pipe(
      switchMap(async (response: any) => { 

        const blobText = await response.body.text();
        const model = JSON.parse(blobText);
        const blobModel = this.base64ToBlob(model.FileBase64,  model.ContentType )
        const url = URL.createObjectURL(blobModel);
        return url;
 
      }),
      catchError(this.parseErrorBlob)
    );
  }

  // downloadBase64WithPostObservable(model: any, method: string, callback?: () => void, error?: () => void) {
  //   let url = this.baseUrl;
  //   if (!!method) {
  //     url = `${this.baseUrl}${method}`;
  //   }

  //   return this.http.post(url, model, { responseType: 'blob', observe: 'response' })
  //     .pipe(
  //       switchMap(async (response: any) => {

  //         const blobText = await response.body.text();
  //         const model: FileDownload = JSON.parse(blobText);
  //         if (!!callback) {
  //           callback();
  //         }

  //         this.convertBase64ToPDF(model);
  //       }),
  //       catchError(this.parseErrorBlob)
  //     );
  // }

  // downloadBase64WithGetObservable(method: string, callback?: () => void, error?: () => void) {
  //   let url = this.baseUrl;
  //   if (!!method) {
  //     url = `${this.baseUrl}${method}`;
  //   }

  //   return this.http.get(url, { responseType: 'blob', observe: 'response' })
  //     .pipe(
  //       switchMap(async (response: any) => {

  //         const blobText = await response.body.text();
  //         const model: FileDownload = JSON.parse(blobText);
  //         if (!!callback) {
  //           callback();
  //         }

  //         this.convertBase64ToPDF(model);
  //       }),
  //       catchError(this.parseErrorBlob)
  //     );
  // }


  private parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();
    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        observer.error({ error: JSON.parse(reader.result as string) });
        observer.complete();
      }
    });

    reader.readAsText(err.error);
    return obs;
  }

  // convertBase64ToPDF(fileModel: FileDownload) {
  //   const blob = this.base64ToBlob(fileModel.FileBase64, fileModel.ContentType);
  //   const blobUrl = URL.createObjectURL(blob);

  //   const link = document.createElement('a');

  //   link.href = blobUrl;
  //   link.download = fileModel.FileName;


  //   document.body.appendChild(link);

  //   link.click();

  //   document.body.removeChild(link);
  // }


  base64ToBlob(base64Data: string, contentType: string): Blob {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  private data: any;

  setData(data: any) {
    this.data = data;
  }

  getData() {
    return this.data;
  }
}


